import React from 'react';
import { Link } from 'react-router-dom';
import CelestialLayout from '../components/celestial/CelestialLayout';
import TopNav from '../components/celestial/TopNav';
import SiteFooter from '../components/celestial/SiteFooter';
import MaterialIcon from '../components/celestial/MaterialIcon';

export default function HesapSil() {
  return (
    <CelestialLayout>
      <TopNav />
      <main className="celestial-main celestial-section-pad">
        <div className="celestial-container" style={{ maxWidth: '560px' }}>
          <h1 className="celestial-headline-xl">Hesap silme</h1>
          <p className="celestial-body-lg" style={{ marginBottom: '2rem' }}>
            Astro Social hesabınızı ve tüm verilerinizi kalıcı olarak silmek için aşağıdaki
            yöntemlerden birini kullanabilirsiniz.
          </p>

          <article className="celestial-glass" style={{ padding: '1.5rem', marginBottom: '1.5rem' }}>
            <h2 className="celestial-headline-lg">Uygulama içinden</h2>
            <p className="celestial-body-lg" style={{ fontSize: '0.95rem' }}>
              Astro Social uygulamasında <strong>Profil</strong> sekmesine gidin,{' '}
              <strong>Hesabı sil</strong> veya <strong>Hesap ayarları</strong> bölümünden hesap
              silme işlemini başlatın. Onayladıktan sonra hesabınız ve ilişkili veriler kalıcı
              olarak silinir.
            </p>
          </article>

          <article className="celestial-glass" style={{ padding: '1.5rem', marginBottom: '1.5rem' }}>
            <h2 className="celestial-headline-lg">E-posta ile talep</h2>
            <p className="celestial-body-lg" style={{ fontSize: '0.95rem' }}>
              Hesap silme talebinizi e-posta ile de iletebilirsiniz. Kayıtlı e-posta adresinizden
              yazın; talebiniz en kısa sürede işleme alınacaktır.
            </p>
            <p style={{ marginTop: '1rem' }}>
              <a href="mailto:destek@astroai.work?subject=Hesap%20silme%20talebi" className="celestial-btn-primary">
                destek@astroai.work
              </a>
            </p>
          </article>

          <p className="celestial-caption" style={{ textTransform: 'none', lineHeight: 1.6 }}>
            Silme işlemi tamamlandıktan sonra hesabınız ve verileriniz geri getirilemez.
            Abonelikleriniz varsa önce iptal etmeniz gerekebilir.
          </p>

          <p style={{ marginTop: '2rem' }}>
            <Link to="/" className="celestial-btn-ghost">
              <MaterialIcon name="arrow_back" size={18} />
              Ana sayfaya dön
            </Link>
            {' · '}
            <Link to="/profil" className="celestial-btn-ghost">
              Profil
            </Link>
          </p>
        </div>
      </main>
      <SiteFooter />
    </CelestialLayout>
  );
}
